import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Card } from 'react-bootstrap';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import './confirm.css';

import { errorAction } from '../../../actions/request_error';
import { successAction } from '../../../actions/successAction';
// import logo from '../../../assets/images/logo.png';
import { conf } from '../../../confg';
import { MAX_ONLINE_TRANSACTION_TOMAN, ENABLE_GOLD_WALLET_IN_CART } from '../../../themeSetting';
import InPlaceLoader from '../../InPlaceLoader';
import { getBasket, set_all_default, set_cart_sanad } from '../../../actions/cartActions';
import { set_me } from '../../../actions/user';
// import CardHeader from './components/CardHeader.js';
import ProductsList from './components/ProductsList';
import CardFooter from './components/CardFooter';
import ConfirmButton from './components/ConfirmButton.js';
import VPNModal from './components/VPNModal';
import MinimumOrderModal from './MinimumOrderModal';
import { ROUTES } from '../../profileInfo/constant/Routes.js';
import CardHeader from './components/CardHeader.js';

const Confirm = (props) => {
  const [products, setProducts] = useState([]);
  const [wait, setWait] = useState('d-none');
  const [confirmed, setConfirmed] = useState(false);
  const [showVPNModal, setShowVPNModal] = useState(true);
  const [checkBasket, setCheckBasket] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [notAccept, setNotAccept] = useState(false);

  const history = useHistory();
  const location = useLocation();
  const confirmBtn = useRef();

  const {
    translate,
    user,
    total_price,
    price_shipping,
    discount,
    credit,
    deposit_price,
    pay_type,
    total_gr,
    order_address,
    order_shipping,
    time_index,
    date,
    discountCode,
    total_discount,
  } = props;

  useEffect(() => {
    window.scrollTo(0, 0);

    lastCheck();

    if (Object.keys(user).length === 0) {
      props.set_me();
    }

    if (!props.order_shipping) {
      props.prevStep();
    }
  }, []);

  const lastCheck = async () => {
    try {
      const response = await axios({
        url: `${conf.server_url}check_cart`,
        method: 'GET',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });

      const { out, gold_changed, exists } = response.data;

      if (out.length > 0) {
        props.errorAction('موجودی انبار تغیر کرده است لیست محصولات را چک کنید');
        history.push({
          pathname: ROUTES.MARKET_PLACE,
          state: {
            showModal: true,
            modalMessage: 'موجودی انبار تغیر کرده است لیست محصولات را چک کنید',
          },
        });
        return;
      }

      if (gold_changed.length > 0) {
        props.errorAction('قیمت طلا تغییر کرده است سبد خرید را مجدد چک کنید');
        return;
      }

      props.successAction('همه چیز برای ثبت نهایی آماده است');
      setProducts(exists);
      setCheckBasket(true);

      if (confirmBtn.current) {
        window.scrollTo(0, confirmBtn.current.offsetTop);
      }
    } catch (error) {
      setCheckBasket(false);
      history.push({
        pathname: ROUTES.MARKET_PLACE,
        state: {
          showModal: true,
          modalMessage: error?.response?.data?.msg || 'خطایی رخ داده است',
        },
      });
    }
  };

  const buildPaymentUrl = () => {
    const addressIdForPay = order_address === 'in_person' ? 0 : order_address;
    const params = new URLSearchParams({
      address_id: addressIdForPay,
      shipping_method_id: order_shipping,
      time_index: time_index,
      date: date,
      payment_type: pay_type === 'deposit' ? '2' : '1',
      jwt: localStorage.getItem('token'),
      coupon_code: discountCode || '',
    });

    if (ENABLE_GOLD_WALLET_IN_CART) {
      params.set('use_gold_gram_wallet', (props.gold_gram_cart_usage || 0) > 0 ? 'true' : 'false');
    }

    return `${conf.server_url}pay?${params.toString()}`;
  };

  const saveSanad = () => {
    setWait('d-flex');
    setConfirmed(true);
    window.location = buildPaymentUrl();
  };

  const handleNotAccept = () => {
    setShowModal(false);
    setNotAccept(true);
  };

  const isTeammate = user?.is_teammate === 1;
  const isWalletPayment = (pay_type === 'deposit' && deposit_price - credit / 10 <= 0) || total_price - credit / 10 <= 0;
  const hasLargeOrder = +total_price + +price_shipping >= MAX_ONLINE_TRANSACTION_TOMAN;
  const showWalletInfo = !hasLargeOrder || hasLargeOrder < 100000000;

  if (notAccept) {
    history.push(ROUTES.MARKET_PLACE);
    return null;
  }

  return (
    <div className='confirm-container'>
      <InPlaceLoader className={wait} />

      <Card className='confirm-card'>
        <CardHeader confirmed={confirmed} history={history} translate={translate} prevStep={props.prevStep} />
        <div className='confirm-card-body'>
          <div className='cart-content'>
            <div className='products-list-container'>
              <ProductsList products={products} isTeammate={isTeammate} translate={translate} />
            </div>
          </div>
        </div>

        {/* <div className='cart-footer'>
          <CardFooter
            isTeammate={isTeammate}
            translate={translate}
            total_price={total_price}
            discount={discount}
            price_shipping={price_shipping}
            order_shipping={order_shipping}
            hasLargeOrder={hasLargeOrder}
            pay_type={pay_type}
            showWalletInfo={showWalletInfo}
            credit={credit}
            deposit_price={deposit_price}
            total_discount={total_discount}
            total_gr={total_gr}
          />
        </div> */}
      </Card>

      <div className='confirm-button-container'>
        <ConfirmButton
          ref={confirmBtn}
          checkBasket={checkBasket}
          total_gr={total_gr}
          isTeammate={isTeammate}
          isWalletPayment={isWalletPayment}
          translate={translate}
          onConfirm={saveSanad}
          onShowModal={() => setShowModal(true)}
        />
      </div>

      <VPNModal show={showVPNModal} onHide={() => setShowVPNModal(false)} className='custom-modal' />

      <MinimumOrderModal show={showModal} total_gr={total_gr} onHide={() => setShowModal(false)} onAccept={saveSanad} onReject={handleNotAccept} className='custom-modal' />
    </div>
  );
};

const mapStateToProps = (state) => ({
  translate: getTranslate(state.localize),
  user: state.user,
  gold: state.gold_price,
  credit: state.cart.cart_credit,
  order_address: state.cart.order_address,
  order_shipping: state.cart.order_shipping,
  price_shipping: state.cart.price_shipping,
  time_index: state.cart.time_index,
  total_discount: state.cart.cart_report.total_discount,
  total_price: state.cart.cart_report.total_price,
  total_weight_to_pay: state.cart.cart_costs.total_weight_to_pay,
  total_gr: state.cart.cart_report.total_gr,
  date: state.cart.date,
  deposit_price: state.deposit_price,
  pay_type: state.pay_type,
  discount: state.discount,
  discountCode: state.discountCode,
  gold_gram_cart_usage: state.cart.gold_gram_cart_usage,
});

export default connect(mapStateToProps, {
  getBasket,
  set_me,
  errorAction,
  successAction,
  set_all_default,
  set_cart_sanad,
})(Confirm);
